import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { loader } from "../../loader";
import { getData, postData } from "../../axios/apiHelper";
import { ENDPOINT } from "../../axios/apiConfig";
import { surveyAxiosInstance } from "../surveybuilder/CommonFunctions/CommonFunction";
const AskIbuModal = ({ show, setShow, topics, setTopics, allTags = [], setAllTags ,questionId,setUpdatdeData}) => {
    const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
    const [newTag, setNewTag] = useState("");
    const [error, setError] = useState("");

    const handleClose = () => {
        setShow(false);
        setError("");
        setNewTag("");
    };

    const handleTagClick = (e, tag) => {
        e.preventDefault()
        if (!topics.includes(tag)) {
            setTopics((prev) => [...prev, tag]);
        }
        else {
            toast.error("Topic already selected.");
        }
    };

const saveNewTopics = async () => {
    try {
        loader("show");
        const res = await postData(ENDPOINT.UPDATEIBUTOPICS, {
            questionId,
            topics
        });

        if (res.status === 200) {
            setUpdatdeData(prev => !prev);
        }

        loader("hide");
        toast.success("Topics added successfully");
        handleClose(); 
    } catch (err) {
        loader("hide");
        toast.error("Failed to add topic");
        console.error("saveNewTopics error:", err); 
    }
};


    const removeTag = (index) => {
        setTopics((prev) => prev.filter((_, i) => i !== index));
    };

    const addTag = async () => {

        if (typeof newTag == "undefined" || newTag.trim().length == 0) {
            setError("Please enter a topic");
            toast.error("Please enter a topic");
            return;
        }

        const lower = newTag.trim().toLowerCase();
        const allExisting = [...allTags, ...topics].map((t) => t.toLowerCase());

        if (allExisting.includes(lower)) {
            toast.error("Topic already exists.");
            return;
        }

        try {
            loader("show");
            await postData(ENDPOINT.ADD_SPC_PRODUCT, {
                user_id: localStorage.getItem("user_id"),
                product: newTag.trim(),
                category: 0,
                type: 2,
            });
            loader("hide");
        } catch (err) {
            loader("hide");
            toast.error("Failed to add topic");
            return;
        }

        setTopics((prev) => [...prev, newTag.trim()]);
         setAllTags((prev) => [...prev, newTag.trim()]);
        setNewTag("");
        setError("");
    };

    return (
        <Modal show={show} id="tagsModal" onHide={handleClose} backdrop="static" className="narrative-tag-modal">
            <Modal.Header>
                <h5>Edit Topics</h5>
                <button type="button" className="btn-close" onClick={handleClose}></button>
            </Modal.Header>
            <Modal.Body>
                <div className="select-tags">
                    <h6>Select Topics :</h6>
                    <div className="tag-lists">
                        <div className="tag-lists-view">
                            {allTags?.map((tag, idx) => (
                                <div key={idx} onClick={(e) => handleTagClick(e, tag)}>
                                    {tag}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="selected-tags">
                    <h6>
                        Selected topics <span>| {(topics && topics.length) || 0}</span>
                    </h6>
                    <div className="total-selected">
                        {Array.isArray(topics) &&
                            topics.map((tag, index) => (
                                <div className="tag-cross" key={index}>
                                    {tag}
                                    <img
                                        src={path_image + "filter-close.svg"}
                                        alt="Remove"
                                        onClick={() => removeTag(index)}
                                    />
                                </div>
                            ))}

                    </div>
                </div>
            </Modal.Body>


            <Modal.Footer>
                <form>
                    <div className="form-group">
                        <label htmlFor="new-tag">New Topic</label>
                        <input
                            type="text"
                            className="form-control"
                            id="new-tag"
                            value={newTag}
                            onChange={(e) => setNewTag(e.target.value)}
                        />

                        <button
                            onClick={addTag}
                            type="button"
                            className="btn btn-primary add btn-bordered"
                        >
                            Add
                        </button>
                    </div>
                </form>
                <button
                    type="button"
                    className="btn btn-primary save btn-filled"
                     onClick={saveNewTopics}
                >
                    Save
                </button>
            </Modal.Footer>

        </Modal>
    );
};

export default AskIbuModal;
